// extracted by mini-css-extract-plugin
module.exports = {"summaryList":"style_summaryList__Kilvq","stats":"style_stats__GB5wJ","col":"style_col__C7lzO"};